import { SHContainer } from "@components/design-systems";
import { TopBar, TopBarContainer } from "@layouts/top-bar";
import { ModelScreenerTableLayout } from "@pages/managed-accounts/model-screener/components/model-screener-table";
import {
  ModelScreenerExportButton
} from "@pages/managed-accounts/model-screener/components/model-screener-export";
import { useUnmount } from "react-use";
import { useAppDispatch } from "@redux/store";
import { resetAppliedFilter } from "@redux/slices/model-screener";

const ModelScreener = () => {
  const dispatch = useAppDispatch();

  useUnmount(() => {
    dispatch(resetAppliedFilter())
  })
  
  return (
    <SHContainer sx={{ px: { xs: 0 } }} maxWidth={false}>
      <TopBarContainer>
        <TopBar
          title={"Managed account analysis"}
          tools={<ModelScreenerExportButton />}
        />
      </TopBarContainer>
      <ModelScreenerTableLayout />
    </SHContainer>
  );
};

export default ModelScreener;
